module.exports = __webpack_public_path__ + "static/img/5.c8526f7e.jpg";